import type { SanityPageBuilderSection, SanityPageBuilderShopStatementSection } from "@ouster/shared";
import { ShopStatementBlockView } from "~/features/blocks/inventory/shop-statement";
type Props = {
  section: SanityPageBuilderSection & {
    loaded?: boolean;
    sectionContent: SanityPageBuilderShopStatementSection;
  };
};
export function SanityShopStatementSection({
  section
}: Props) {
  const {
    sectionContent,
    sectionSettings
  } = section;
  return <ShopStatementBlockView anchor={{
    id: sectionSettings?.sectionId?.current || sectionSettings?.anchorName || section._key,
    name: sectionSettings?.anchorName
  }} hasTopDivider={sectionSettings?.hasTopDivider ?? true} mode={sectionSettings?.mode || "light"} theme={sectionSettings?.theme || "white"} headline={sectionContent.headline} sectionProps={{
    "data-sanity-section-key": section._key,
    "data-sanity-section-type": section._type
  }} />;
}